import LogoIcon from '@/assets/icons/Logo.tsx';
import { RouteEnum } from '@/layouts/routes/model/Route.model.ts';
import { useAppHistory } from '@/utils/useAppHistory.util.ts';
import { Box } from '@mui/material';
import React from 'react';

import { LogoStyles } from './logo.styles.ts';

export const Logo: React.FC = () => {
  const { push } = useAppHistory();

  const handleClick = () => {
    push(RouteEnum.ROOT);
  };

  return (
    <Box onClick={handleClick} sx={LogoStyles}>
      <LogoIcon sx={{ height: '100%', width: '100%' }} />
    </Box>
  );
};
